/**
 * @module helpers/slick
 * This module defines helper functions for slick gallery dot css
 */

const maxVisibleDots = 5;

// ((width * numberDots) + (margin * 2 * numberDots) / 2) - margin = ((10 * 5) + (8 * 2 * 5) / 2) - 8
const baseMargin = -57;

/**
 * Adds classes before the active slide and handles margins
 * @param {Number} activeIndex index value of active slide (0-indexed)
 * @param {JQuery<HTMLElement>} $liArray jquery object with list of slides
 * @param {Boolean} hasLessImages boolean indicating the total images are less than the {@link maxVisibleDots}
 * @returns {void}
 */
const handleSlickCss = function(activeIndex, $liArray, hasLessImages) {
	const $activeElement = $($liArray[activeIndex]);
	// reset classes
	$liArray
		.removeClass('before-slick-active')
		.removeClass('second-before-slick-active')
		.removeClass('third-before-slick-active')
		.removeClass('fourth-before-slick-active');
	// add identifying classes before active li
	$activeElement
		.prev()
		.addClass('before-slick-active')
		.prev()
		.addClass('second-before-slick-active')
		.prev()
		.addClass('third-before-slick-active')
		.prev()
		.addClass('fourth-before-slick-active');
	// manually cancel out margins on non visible dots to left of active dot
	if (!hasLessImages) {
		$($liArray[0]).css('margin-left', `${baseMargin - Math.max(0, activeIndex - 2) * 16}px`);
	} else {
		// Reset the margin
		$($liArray[0]).css('margin-left', 'initial');
	}
};
module.exports = {
	/**
	 * Calls css handler immediately and sets listener on $slider change event
	 * @param {JQuery<HTMLElement>} $slider $('.js-img-swipe') jquery object
	 * @returns {void}
	 */
	addClassesToLi: function($slider) {
		if (!$slider) {
			return;
		}
		const $liArray = $slider.find('li');
		const hasLessImages = $liArray.length < maxVisibleDots;
		// Handle cases where there are images less than maxVisibleDots
		if (hasLessImages) {
			$slider.find('.slick-dots').css({ 'text-align': 'center', left: '0' });
		}
		const initialActiveSlide = $liArray.filter('.slick-active').get(0);
		// handles case where sliders initialize with active slide in middle of gallery
		this.handleSlickCss($liArray.toArray().indexOf(initialActiveSlide), $liArray, hasLessImages);
		$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
			this.handleSlickCss(nextSlide, $liArray, hasLessImages);
		});
	},
	handleSlickCss: handleSlickCss
};
